import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import "./kontaktFormularForm.scss";
import axios from "axios";
import toast, { Toaster } from "react-hot-toast";

export default function KontaktFormularForm() {
  const [contactData, setContactData] = useState<any>({});
  const [errors, setErrors] = useState<any>({});
  const [codChecked, setCodChecked] = useState<any>("");
  const [showErrors, setShowErrors] = useState<any>(false);
  const [cardsData, setCardsData] = useState<any>([]);
  const [checked, setChecked] = useState<String>("");
  const [checked1, setChecked1] = useState<String>("");
  const [checked2, setChecked2] = useState<String>("");
  const [zumchecked, setZumChecked] = useState<String>("no");
  const [basechecked, setBaseChecked] = useState<String>("no");
  const [basechecked1, setBaseChecked1] = useState<String>("no");
  // const [endDate, setEndDate] = useState<any>(new Date(date));

  const clearData = () => {
    setContactData({
      zumchecked: "no",
      basechecked: "no",
      basechecked1: "no",

      checked: "",
      checked1: "",
      checked2: "",
      suchort: "",
      stadtteile: "",
      anzahlzimmer: "",
      maxgro: "",
      anzahlpersonen: "",
      kaufpreis: "",
      von: "",
      bis: "",
      beschreibung: "",
      firstname: "",
      nachname: "",
      firma: "",
      Strabe: "",
      postleitzahl: "",
      orts: "",
      land: "",
      emails: "",
      telefonprivat: "",
      telefonberuflich: "",
      fax: "",
      mobil: "",
    });
  };

  const handleChange = (e: any) => {
    setContactData({ ...contactData, [e.target.name]: e.target.value });

    setErrors({ ...errors, [e.target.name]: "" });
  };

  const handleOnChange = (e: any) => {
    setChecked(e.target.value);
    setErrors({ ...errors, checked: "" });
  };

  useEffect(() => {
    console.log("checked", checked.length);
  }, [checked]);

  const handleOnChange1 = (e: any) => {
    setChecked1(e.target.value);
    setErrors({ ...errors, checked1: "" });
  };

  useEffect(() => {
    console.log("checked11", checked1);
  }, [checked1]);

  const handleOnChange2 = (e: any) => {
    setChecked2(e.target.value);
    setErrors({ ...errors, checked2: "" });
  };

  useEffect(() => {
    console.log("checked22", checked2);
  }, [checked2]);
  console.log("zumchecked", basechecked, basechecked1);

  const regex =
    /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

  const handleContactUs = async () => {
    if (
      !contactData.suchort &&
      !contactData.stadtteile &&
      !contactData.anzahlzimmer &&
      !contactData.maxgro &&
      !contactData.anzahlpersonen &&
      !contactData.kaufpreis &&
      // !zumchecked  &&
      !contactData.von &&
      !contactData.bis &&
      // !checked2 &&
      !contactData.beschreibung &&
      !contactData.firstname &&
      !contactData.nachname &&
      !contactData.firma &&
      !contactData.Strabe &&
      !contactData.postleitzahl &&
      !contactData.orts &&
      !contactData.land &&
      !contactData.emails &&
      !contactData.telefonprivat &&
      !contactData.telefonberuflich &&
      !contactData.fax &&
      !contactData.mobil &&
      !checked1 &&
      !checked2 &&
      !checked
      // !codChecked || !codChecked === false
    ) {
      setErrors({
        ...errors,
        checked: "Bitte überprüfen Sie ihre Eingabe.",
        checked1: "Bitte überprüfen Sie ihre Eingabe.",
        checked2: "Bitte überprüfen Sie ihre Eingabe.",
        suchort: "Bitte überprüfen Sie ihre Eingabe.",
        stadtteile: "Bitte überprüfen Sie ihre Eingabe.",
        anzahlzimmer: "Bitte überprüfen Sie ihre Eingabe.",
        maxgro: "Bitte überprüfen Sie ihre Eingabe.",
        anzahlpersonen: "Bitte überprüfen Sie ihre Eingabe.",
        kaufpreis: "Bitte überprüfen Sie ihre Eingabe.",
        von: "Bitte überprüfen Sie ihre Eingabe.",
        bis: "Bitte überprüfen Sie ihre Eingabe.",
        beschreibung: "Bitte überprüfen Sie ihre Eingabe.",
        firstname: "Bitte überprüfen Sie ihre Eingabe.",
        nachname: "Bitte überprüfen Sie ihre Eingabe.",
        firma: "Bitte überprüfen Sie ihre Eingabe.",
        Strabe: "Bitte überprüfen Sie ihre Eingabe.",
        postleitzahl: "Bitte überprüfen Sie ihre Eingabe.",
        orts: "Bitte überprüfen Sie ihre Eingabe.",
        land: "Bitte überprüfen Sie ihre Eingabe.",
        emails: "Bitte überprüfen Sie ihre Eingabe.",
        telefonprivat: "Bitte überprüfen Sie ihre Eingabe.",
        telefonberuflich: "Bitte überprüfen Sie ihre Eingabe.",
        fax: "Bitte überprüfen Sie ihre Eingabe.",
        mobil: "Bitte überprüfen Sie ihre Eingabe.",
      });
      setShowErrors(true);
    }
    // else if (!checked1) {
    //   setErrors({ ...errors, checked1: "Bitte überprüfen Sie ihre Eingabe." });
    //   setShowErrors(true);
    // }
    else if (checked.length === 0) {
      console.log("erorrrrrrrrrrrrrrr");
      setErrors({ ...errors, checked: "Bitte überprüfen Sie ihre Eingabe." });
      setShowErrors(true);
    } else if (!contactData.suchort) {
      setErrors({ ...errors, suchort: "Bitte überprüfen Sie ihre Eingabe." });
      setShowErrors(true);
    } else if (!contactData.stadtteile) {
      setErrors({
        ...errors,
        stadtteile: "Bitte überprüfen Sie ihre Eingabe.",
      });
      setShowErrors(true);
    } else if (!contactData.anzahlzimmer) {
      setErrors({
        ...errors,
        anzahlzimmer: "Bitte überprüfen Sie ihre Eingabe.",
      });
      setShowErrors(true);
    } else if (!contactData.maxgro) {
      setErrors({ ...errors, maxgro: "Bitte überprüfen Sie ihre Eingabe." });
      setShowErrors(true);
    } else if (!contactData.anzahlpersonen) {
      setErrors({
        ...errors,
        anzahlpersonen: "Bitte überprüfen Sie ihre Eingabe.",
      });
      setShowErrors(true);
    } else if (!contactData.anzahlzimmer) {
      setErrors({
        ...errors,
        anzahlzimmer: "Bitte überprüfen Sie ihre Eingabe.",
      });
      setShowErrors(true);
    } else if (!contactData.kaufpreis) {
      setErrors({ ...errors, kaufpreis: "Bitte überprüfen Sie ihre Eingabe." });
      setShowErrors(true);
    } else if (!contactData.von) {
      setErrors({ ...errors, von: "Bitte überprüfen Sie ihre Eingabe." });
      setShowErrors(true);
    } else if (!contactData.bis) {
      setErrors({ ...errors, bis: "Bitte überprüfen Sie ihre Eingabe." });
      setShowErrors(true);
    } else if (!contactData.beschreibung) {
      setErrors({
        ...errors,
        beschreibung: "Bitte überprüfen Sie ihre Eingabe.",
      });
      setShowErrors(true);
    } else if (!contactData.firstname) {
      setErrors({ ...errors, firstname: "Bitte überprüfen Sie ihre Eingabe." });
      setShowErrors(true);
    } else if (!contactData.nachname) {
      setErrors({ ...errors, nachname: "Bitte überprüfen Sie ihre Eingabe." });
      setShowErrors(true);
    } else if (!contactData.firma) {
      setErrors({ ...errors, firma: "Bitte überprüfen Sie ihre Eingabe." });
      setShowErrors(true);
    } else if (!contactData.Strabe) {
      setErrors({ ...errors, Strabe: "Bitte überprüfen Sie ihre Eingabe." });
      setShowErrors(true);
    } else if (!contactData.postleitzahl) {
      setErrors({
        ...errors,
        postleitzahl: "Bitte überprüfen Sie ihre Eingabe.",
      });
      setShowErrors(true);
    } else if (!contactData.orts) {
      setErrors({ ...errors, orts: "Bitte überprüfen Sie ihre Eingabe." });
      setShowErrors(true);
    } else if (!contactData.land) {
      setErrors({ ...errors, land: "Bitte überprüfen Sie ihre Eingabe." });
      setShowErrors(true);
    } else if (!contactData.orts) {
      setErrors({ ...errors, orts: "Bitte überprüfen Sie ihre Eingabe." });
      setShowErrors(true);
    } else if (!regex.test(contactData.emails)) {
      setErrors({ ...errors, emails: "Bitte überprüfen Sie ihre Eingabe." });
      setShowErrors(true);
    } else if (
      !contactData.telefonprivat ||
      contactData.telefonprivat?.length > 14
    ) {
      // toast.error("Please Enter your Last Name");
      setErrors({
        ...errors,
        telefonprivat: "Bitte überprüfen Sie ihre Eingabe.",
      });
      setShowErrors(true);
    } else if (
      !contactData.telefonberuflich ||
      contactData.telefonberuflich?.length > 14
    ) {
      // toast.error("Please Enter your Last Name");
      setErrors({
        ...errors,
        telefonberuflich: "Bitte überprüfen Sie ihre Eingabe.",
      });
      setShowErrors(true);
    } else if (!contactData.mobil || contactData.mobil?.length > 14) {
      // toast.error("Please Enter your Last Name");
      setErrors({ ...errors, mobil: "Bitte überprüfen Sie ihre Eingabe." });
      setShowErrors(true);
    } else if (!contactData.fax) {
      setErrors({ ...errors, fax: "Bitte überprüfen Sie ihre Eingabe." });
      setShowErrors(true);
    } else {
      const body = {
        buyOrRent: checked,
        location: contactData.suchort,
        district: contactData.stadtteile,
        whatBuyOrRent: checked1,
        rooms: contactData.anzahlzimmer,
        size: contactData.maxgro,
        people: contactData.anzahlpersonen,
        price: parseInt(contactData.kaufpreis),
        zumKauf: zumchecked,
        of: contactData.von,
        until: contactData.bis,
        objectDescription: checked2,
        description: contactData.beschreibung,
        fname: contactData.firstname,
        sname: contactData.nachname,
        business: contactData.firma,
        street: contactData.Strabe,
        postcode: parseInt(contactData.postleitzahl),
        city: contactData.orts,
        country: contactData.land,
        email: contactData.emails,
        privatePhone: parseInt(contactData.telefonprivat),
        phoneForWork: parseInt(contactData.telefonberuflich),
        fax: contactData.fax,
        mobile: parseInt(contactData.mobil),
        checkbox1 :basechecked,

        checkbox2 :basechecked1,
      };
      console.log("opp", body);
      clearData();
      // toast.success("Suchanfrage erstellt");
      await axios
        .post(
          "https://api.deutscher.rejoicehub.com/api/v1/search-request/create",
          body
        )
        .then((res: any) => {
          toast.success("Suchanfrage erstellt");

          console.log(res);
          setContactData({});
          clearData();
          window.location.reload();
        })
        .catch((err: any) => {
          console.log("err", err);
        });
    }
  };
  console.log("1contactData", basechecked1);

  return (
    <>
      <Toaster />
      <div>
        <div className="kontakt-form-center-alignment">
          <div className="kontakt-form">
            <h4>Ihr Wunschobjekt</h4>
            <div className="first-text">
              <p>Kaufen oder Mieten?</p>{" "}
              {showErrors && (
                <span style={{ fontSize: "10px", color: "red" }}>
                  {errors.checked}
                </span>
              )}
              <div className="all-input-radio-bottom-alignment">
                <div className="input-radio-alignment">
                  <input
                    type="radio"
                    name="test"
                    id="test4"
                    value="zum Kauf"
                    onChange={handleOnChange}
                  />
                  <label htmlFor="test4">
                    <span>zum Kauf</span>
                  </label>
                </div>
                <div className="input-radio-alignment">
                  <input
                    type="radio"
                    name="test"
                    id="test2"
                    value="zur Miete"
                    onChange={handleOnChange}
                  />
                  <label htmlFor="test2">
                    <span>zur Miete</span>
                  </label>
                </div>
                <div className="input-radio-alignment">
                  <input
                    type="radio"
                    name="test"
                    id="test"
                    value="zum Kauf oder zur Miete"
                    onChange={handleOnChange}
                  />
                  <label htmlFor="test">
                    <span>zum Kauf oder zur Miete</span>
                  </label>
                </div>
              </div>
            </div>
            <div className="ort-content-alignment">
              <p>Ort</p>
              <div className="two-col-grid">
                <div className="input">
                  <label>Suchort*</label>
                  <input
                    type="text"
                    name="suchort"
                    value={contactData.suchort && contactData.suchort}
                    onChange={(e) => handleChange(e)}
                  />
                  {showErrors && (
                    <span style={{ fontSize: "10px", color: "red" }}>
                      {errors.suchort}
                    </span>
                  )}
                </div>
                <div className="input">
                  <label>Stadtteile</label>
                  <input
                    type="text"
                    name="stadtteile"
                    value={contactData.stadtteile && contactData.stadtteile}
                    onChange={(e) => handleChange(e)}
                  />
                  {showErrors && (
                    <span style={{ fontSize: "10px", color: "red" }}>
                      {errors.stadtteile}
                    </span>
                  )}
                </div>
              </div>
            </div>
            <div className="kaufen-all-content-alignment">
              <p>Kaufen oder Mieten?</p>
              <div className="col-three-grid">
                <div className="col-three-grid-items">
                  <div className="all-radio-new-alignment">
                    {" "}
                    {showErrors && (
                      <span style={{ fontSize: "10px", color: "red" }}>
                        {errors.checked1}
                      </span>
                    )}
                    <div className="input-radio-alignment">
                      <input
                        type="radio"
                        name="Karrierenstitut"
                        id="a1"
                        value="Zimmer"
                        onChange={handleOnChange1}
                      />
                      <label htmlFor="a1">
                        <span>Zimmer</span>
                      </label>
                    </div>
                    <div className="input-radio-alignment">
                      <input
                        type="radio"
                        name="Karrierenstitut"
                        id="a2"
                        value="Apartement"
                        onChange={handleOnChange1}
                      />
                      <label htmlFor="a2">
                        <span>Apartement</span>
                      </label>
                    </div>
                    <div className="input-radio-alignment">
                      <input
                        type="radio"
                        name="Karrierenstitut"
                        id="a3"
                        value="Wohnung"
                        onChange={handleOnChange1}
                      />
                      <label htmlFor="a3">
                        <span>Wohnung</span>
                      </label>
                    </div>
                    <div className="input-radio-alignment">
                      <input
                        type="radio"
                        name="Karrierenstitut"
                        id="a4"
                        value="Haus"
                        onChange={handleOnChange1}
                      />
                      <label htmlFor="a4">
                        <span>Haus</span>
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-three-grid-items">
                  <div className="all-radio-new-alignment">
                    <div className="input-radio-alignment">
                      <input
                        type="radio"
                        name="Karrierenstitut"
                        id="a5"
                        value="Mehrfamilienhaus"
                        onChange={handleOnChange1}
                      />
                      <label htmlFor="a5">
                        <span>Mehrfamilienhaus</span>
                      </label>
                    </div>
                    <div className="input-radio-alignment">
                      <input
                        type="radio"
                        name="Karrierenstitut"
                        id="a6"
                        value="Wohn-/Geschäftshaus"
                        onChange={handleOnChange1}
                      />
                      <label htmlFor="a6">
                        <span>Wohn-/Geschäftshaus</span>
                      </label>
                    </div>
                    <div className="input-radio-alignment">
                      <input
                        type="radio"
                        name="Karrierenstitut"
                        id="a7"
                        value="Gewerbeobjekt"
                        onChange={handleOnChange1}
                      />
                      <label htmlFor="a7">
                        <span>Gewerbeobjekt</span>
                      </label>
                    </div>
                    <div className="input-radio-alignment">
                      <input
                        type="radio"
                        name="Karrierenstitut"
                        id="a8"
                        value="Grundstück"
                        onChange={handleOnChange1}
                      />
                      <label htmlFor="a8">
                        <span>Grundstück</span>
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-three-grid-items">
                  <div className="all-radio-new-alignment">
                    <div className="input-radio-alignment">
                      <input
                        type="radio"
                        name="Karrierenstitut"
                        id="a9"
                        value="Sonstige Objektart"
                        onChange={handleOnChange1}
                      />
                      <label htmlFor="a9">
                        <span>Sonstige Objektart</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="zimmer-text-alignment">
              <p>Zimmer/ Größe</p>
              <div className="two-col-grid">
                <div className="input">
                  <label>Anzahl Zimmer</label>
                  <input
                    type="number"
                    name="anzahlzimmer"
                    value={contactData.anzahlzimmer && contactData.anzahlzimmer}
                    onChange={(e) => handleChange(e)}
                  />
                  {showErrors && (
                    <span style={{ fontSize: "10px", color: "red" }}>
                      {errors.anzahlzimmer}
                    </span>
                  )}
                </div>
                <div className="input">
                  <label> Max. Größe in m2</label>
                  <input
                    type="number"
                    name="maxgro"
                    value={contactData.maxgro && contactData.maxgro}
                    onChange={(e) => handleChange(e)}
                  />
                  {showErrors && (
                    <span style={{ fontSize: "10px", color: "red" }}>
                      {errors.maxgro}
                    </span>
                  )}
                </div>
                <div className="input">
                  <label>Anzahl Personen</label>
                  <input
                    type="number"
                    name="anzahlpersonen"
                    value={
                      contactData.anzahlpersonen && contactData.anzahlpersonen
                    }
                    onChange={(e) => handleChange(e)}
                  />
                  {showErrors && (
                    <span style={{ fontSize: "10px", color: "red" }}>
                      {errors.anzahlpersonen}
                    </span>
                  )}
                </div>
              </div>
            </div>
            <div className="miet-content">
              <p>Miet-/ Kaufpreiss</p>
              <div className="two-col-grid">
                <div className="input">
                  <label> Max. Miete/ Kaufpreis</label>
                  <input
                    type="number"
                    name="kaufpreis"
                    value={contactData.kaufpreis && contactData.kaufpreis}
                    onChange={(e) => handleChange(e)}
                  />
                  {showErrors && (
                    <span style={{ fontSize: "10px", color: "red" }}>
                      {errors.kaufpreis}
                    </span>
                  )}
                </div>
              </div>
            </div>
            <div className="zeriraun-content-alignment">
              <p>Zeitraum</p>
              <div className="input-radio-alignment">
                <input
                  type="radio"
                  name="zum"
                  id="zum"
                  value="yes"
                  onChange={(e: any) => setZumChecked(e.target.value)}
                />
                <label htmlFor="zum">
                  <span>zum Kauf</span>
                </label>
              </div>
              <div className="two-col-grid">
                <div className="input">
                  <label>Von</label>
                  <input
                    type="date"
                    name="von"
                    value={contactData.von && contactData.von}
                    onChange={(e) => handleChange(e)}
                  />
                  {showErrors && (
                    <span style={{ fontSize: "10px", color: "red" }}>
                      {errors.von}
                    </span>
                  )}
                  {/* <DatePicker
                        id="endDate"
                        format="DD/MM/YYYY"
                        selected={new Date(date)}
                        onChange={(date) => {
                          setEndDate(date);
                          setErrors({ ...errors, endDate: "" });
                        }}
                        default
                        // minDate={currentDate}
                      /> */}
                </div>
                <div className="input">
                  <label> Bis</label>
                  <input
                    type="date"
                    name="bis"
                    value={contactData.bis && contactData.bis}
                    onChange={(e) => handleChange(e)}
                  />
                  {showErrors && (
                    <span style={{ fontSize: "10px", color: "red" }}>
                      {errors.bis}
                    </span>
                  )}
                </div>
              </div>
            </div>
            <div className="kaufen-all-content-alignment">
              <p>Objektbeschreibung</p>{" "}
              {showErrors && (
                <span style={{ fontSize: "10px", color: "red" }}>
                  {errors.checked2}
                </span>
              )}
              <div className="col-three-grid">
                <div className="col-three-grid-items">
                  <div className="all-radio-new-alignment">
                    <div className="input-radio-alignment">
                      <input
                        type="radio"
                        name="qq"
                        id="q1"
                        value="Zimmer"
                        onChange={handleOnChange2}
                      />
                      <label htmlFor="q1">
                        <span>Zimmer</span>
                      </label>
                    </div>
                    <div className="input-radio-alignment">
                      <input
                        type="radio"
                        name="qq"
                        id="q2"
                        value="Apartement"
                        onChange={handleOnChange2}
                      />
                      <label htmlFor="q2">
                        <span>Apartement</span>
                      </label>
                    </div>
                    <div className="input-radio-alignment">
                      <input
                        type="radio"
                        name="qq"
                        id="q3"
                        value="Wohnung"
                        onChange={handleOnChange2}
                      />
                      <label htmlFor="q3">
                        <span>Wohnung</span>
                      </label>
                    </div>
                    <div className="input-radio-alignment">
                      <input
                        type="radio"
                        name="qq"
                        id="q4"
                        value="Haus"
                        onChange={handleOnChange2}
                      />
                      <label htmlFor="q4">
                        <span>Haus</span>
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-three-grid-items">
                  <div className="all-radio-new-alignment">
                    <div className="input-radio-alignment">
                      <input
                        type="radio"
                        name="qq"
                        id="q5"
                        value="Mehrfamilienhaus"
                        onChange={handleOnChange2}
                      />
                      <label htmlFor="q5">
                        <span>Mehrfamilienhaus</span>
                      </label>
                    </div>
                    <div className="input-radio-alignment">
                      <input
                        type="radio"
                        name="qq"
                        id="q6"
                        value="Wohn-/Geschäftshaus"
                        onChange={handleOnChange2}
                      />
                      <label htmlFor="q6">
                        <span>Wohn-/Geschäftshaus</span>
                      </label>
                    </div>
                    <div className="input-radio-alignment">
                      <input
                        type="radio"
                        name="qq"
                        id="q7"
                        value="Gewerbeobjekt"
                        onChange={handleOnChange2}
                      />
                      <label htmlFor="q7">
                        <span>Gewerbeobjekt</span>
                      </label>
                    </div>
                    <div className="input-radio-alignment">
                      <input
                        type="radio"
                        name="qq"
                        id="q8"
                        value="Grundstück"
                        onChange={handleOnChange2}
                      />
                      <label htmlFor="q8">
                        <span>Grundstück</span>
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-three-grid-items">
                  <div className="all-radio-new-alignment">
                    <div className="input-radio-alignment">
                      <input
                        type="radio"
                        name="qq"
                        id="q9"
                        value="Sonstige Objektart"
                        onChange={handleOnChange2}
                      />
                      <label htmlFor="q9">
                        <span>Sonstige Objektart</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="textarea-style">
              <div className="input">
                <textarea
                  placeholder="Beschreibung/ Bemerkungen"
                  name="beschreibung"
                  value={contactData.beschreibung && contactData.beschreibung}
                  onChange={(e) => handleChange(e)}
                />
                {showErrors && (
                  <span style={{ fontSize: "10px", color: "red" }}>
                    {errors.beschreibung}
                  </span>
                )}
              </div>
            </div>
            <div className="ihre-daten-all-content-style">
              <p>Ihre Daten</p>
              <div className="two-col-grid">
                <div className="input">
                  <label>Vorname</label>
                  <input
                    type="text"
                    name="firstname"
                    value={contactData.firstname && contactData.firstname}
                    onChange={(e) => handleChange(e)}
                  />
                  {showErrors && (
                    <span style={{ fontSize: "10px", color: "red" }}>
                      {errors.firstname}
                    </span>
                  )}
                </div>
                <div className="input">
                  <label> Nachname*</label>
                  <input
                    type="text"
                    name="nachname"
                    value={contactData.nachname && contactData.nachname}
                    onChange={(e) => handleChange(e)}
                  />
                  {showErrors && (
                    <span style={{ fontSize: "10px", color: "red" }}>
                      {errors.nachname}
                    </span>
                  )}
                </div>
                <div className="input">
                  <label>Firma</label>
                  <input
                    type="text"
                    name="firma"
                    value={contactData.firma && contactData.firma}
                    onChange={(e) => handleChange(e)}
                  />
                  {showErrors && (
                    <span style={{ fontSize: "10px", color: "red" }}>
                      {errors.firma}
                    </span>
                  )}
                </div>
                <div className="input">
                  <label>Straße / Nr.</label>
                  <input
                    type="text"
                    name="Strabe"
                    value={contactData.Strabe && contactData.Strabe}
                    onChange={(e) => handleChange(e)}
                  />
                  {showErrors && (
                    <span style={{ fontSize: "10px", color: "red" }}>
                      {errors.Strabe}
                    </span>
                  )}
                </div>
                <div className="input">
                  <label>Postleitzahl</label>
                  <input
                    type="number"
                    name="postleitzahl"
                    value={contactData.postleitzahl && contactData.postleitzahl}
                    onChange={(e) => handleChange(e)}
                  />
                  {showErrors && (
                    <span style={{ fontSize: "10px", color: "red" }}>
                      {errors.postleitzahl}
                    </span>
                  )}
                </div>
                <div className="input">
                  <label> Ort</label>
                  <input
                    type="text"
                    name="orts"
                    value={contactData.orts && contactData.orts}
                    onChange={(e) => handleChange(e)}
                  />
                  {showErrors && (
                    <span style={{ fontSize: "10px", color: "red" }}>
                      {errors.orts}
                    </span>
                  )}
                </div>
                <div className="input">
                  <label>Land</label>
                  <input
                    type="text"
                    name="land"
                    value={contactData.land && contactData.land}
                    onChange={(e) => handleChange(e)}
                  />
                  {showErrors && (
                    <span style={{ fontSize: "10px", color: "red" }}>
                      {errors.land}
                    </span>
                  )}
                </div>
                <div className="input">
                  <label>Email*</label>
                  <input
                    type="text"
                    name="emails"
                    value={contactData.emails && contactData.emails}
                    onChange={(e) => handleChange(e)}
                  />
                  {showErrors && (
                    <span style={{ fontSize: "10px", color: "red" }}>
                      {errors.emails}
                    </span>
                  )}
                </div>

                <div className="input">
                  <label>Telefon privat</label>
                  <input
                    type="number"
                    name="telefonprivat"
                    value={
                      contactData.telefonprivat && contactData.telefonprivat
                    }
                    onChange={(e) => handleChange(e)}
                  />
                  {showErrors && (
                    <span style={{ fontSize: "10px", color: "red" }}>
                      {errors.telefonprivat}
                    </span>
                  )}
                </div>
                <div className="input">
                  <label>Telefon beruflich</label>
                  <input
                    type="number"
                    name="telefonberuflich"
                    value={
                      contactData.telefonberuflich &&
                      contactData.telefonberuflich
                    }
                    onChange={(e) => handleChange(e)}
                  />
                  {showErrors && (
                    <span style={{ fontSize: "10px", color: "red" }}>
                      {errors.telefonberuflich}
                    </span>
                  )}
                </div>
                <div className="input">
                  <label>Fax</label>
                  <input
                    type="text"
                    name="fax"
                    value={contactData.fax && contactData.fax}
                    onChange={(e) => handleChange(e)}
                  />
                  {showErrors && (
                    <span style={{ fontSize: "10px", color: "red" }}>
                      {errors.fax}
                    </span>
                  )}
                </div>
                <div className="input">
                  <label> Mobil</label>
                  <input
                    type="number"
                    name="mobil"
                    value={contactData.mobil && contactData.mobil}
                    onChange={(e) => handleChange(e)}
                  />
                  {showErrors && (
                    <span style={{ fontSize: "10px", color: "red" }}>
                      {errors.mobil}
                    </span>
                  )}
                </div>
              </div>
            </div>
            <div className="only-radio-label-alignment">
              <div className="input-radio-alignment">
                <div className="radio-new-top-button">
                  <input
                    type="radio"
                    name="base"
                    id="base"
                    value="yes"
                    onChange={(e: any) => setBaseChecked(e.target.value)}
                  />
                  <label htmlFor="base"></label>
                </div>
                <div>
                  <span>
                    Ich/ Wir beauftragen Sie im Rahmen des Bestellerprinzips,
                    mir/ uns eine geeignete Immobilie zu suchen. Kosten
                    entstehen mir/ uns nur bei erfolgreichem
                  </span>
                </div>
              </div>
            </div>
            <div className="new-text-style">
              <p>Ihre Daten</p>
              <div className="input-radio-alignment">
                <div className="radio-new-top-button">
                  <input
                    type="radio"
                    name="r1"
                    id="r1"
                    value="yes"
                    onChange={(e: any) => setBaseChecked1(e.target.value)}
                  />
                  <label htmlFor="r1"></label>
                </div>
                <div>
                  <span>
                    Ich/ Wir stimme(n) der in der Datenschutzerklärung des
                    Deutschen Immobilien Dienstes dargelegten Verarbeitung
                    meiner/unserer personenbezognen(er) Daten zu.
                  </span>
                </div>
              </div>
            </div>
            <div className="last-button-center-alignment">
              {/* <NavLink to="/haftubgasausshluss"> */}
              <button onClick={handleContactUs}>Absenden</button>
              {/* </NavLink> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
